import { render } from "./sendMailComponent.vue?vue&type=template&id=36513d71"
import script from "./sendMailComponent.vue?vue&type=script&lang=js"
export * from "./sendMailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__